export default {
  MuiScopedCssBaseline: {
    styleOverrides: {
      root: {
        width: '100%',
        height: '100%'
      }
    }
  }
};
